import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	width: 100%;

	.checkbox-wrapper {
		position: relative;
		text-align: left;
		cursor: pointer;
		display: flex;
		justify-content: flex-start;
		align-items: center;

		.checkbox-trigger {
			width: 20px;
			height: 20px;
			background-color: #ffffff;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			position: relative;
			border: 1px solid #666666;
			border-radius: 0.2em;

			&:after {
				content: '';
				display: inline-block;
				position: absolute;
				background: #eb8817;
				width: 60%;
				height: 60%;
				opacity: 0;
				transform: scale(0);
				transition: opacity 200ms ease, transform 200ms ease;
			}
		}

		.checkbox {
			position: absolute;
			z-index: -1;
			width: 1px;
			height: 1px;
			margin: 0;
			opacity: 0.01;

			&:checked + .checkbox-trigger,
			&[value='true'] + .checkbox-trigger {
				&:after {
					opacity: 1;
					transform: scale(1);
				}
			}
		}
	}

	.label {
		display: inline-block;
		padding-left: 0.9em;
		text-align: left;
		line-height: 120%;
		font-size: 0.8em;
		color: ${vars.colorTextDarkLighter};
		max-width: 90%;
		margin-top: -0.2em;

		a {
			text-decoration: underline;
            color: ${vars.colorTextDarkLighter};
		}

		.expand-trigger {
			cursor: pointer;
			margin-left: 0.5em;
			text-decoration: underline;
		}
	}

	.layout-forms-input-wrapper {
		.internal-wrapper {
			border: none;
			border-radius: 0;

			.input-body {
				display: flex;
				justify-content: flex-start;
				align-items: flex-start;
			}
		}

		&.error {
			.internal-wrapper {
				border: none !important;
			}
		}
	}

	&.disabled {
		opacity: 0.5;
	}

	&.bold {
		.label {
			font-weight: 600;
		}
	}

	&.style-secondary {
		.layout-forms-input-wrapper {
			.internal-wrapper {
				.input-body {
					display: flex;
					align-items: center;

					.checkbox-wrapper {
						.checkbox-trigger {
							border: 1px solid #c1c1c1;
						}

						.checkbox {
							&:checked + .checkbox-trigger,
							&[value='true'] + .checkbox-trigger {
								&:after {
									background: transparent;
									background-image: url(/images/cart/check-gold.svg);
									background-repeat: no-repeat;
								}
							}
						}
					}
				}
			}
		}
	}

	&.style-required {
		.layout-forms-input-wrapper {
			.internal-wrapper {
				.input-body {
					display: flex;
					align-items: center;

					.checkbox-wrapper {
						.checkbox-trigger {
							border: 2px solid #eb8817;
						}
					}
				}
			}
		}
	}

	@media all and (max-width: ${vars.tabletL}) {
		.label {
			font-size: 1em;
		}
	}
`;
